import * as React from 'react';
import { People } from '@mui/icons-material';
import ReportLayout from '../Components/Reports/ReportLayout';

interface TypeReportProps {
  Entete: string;
  TypeGroup: string;
}

const ListClientFRGroupe: React.FC<TypeReportProps> = ({ Entete, TypeGroup }) => {
  return (
    <ReportLayout
      title={Entete}
      subtitle="Module Clients · Par groupe"
      icon={<People />}
      endpoint="module-clientsbygroupe"
      extraParams={{ Type: TypeGroup }}
      showClientRange={false}
      showDateRange={true}
      showAgence={true}
      extraFields={[
        {
          key: 'ListGroup',
          label: 'Sélection de groupe',
          type: 'multiselect',
          fetchUrl: 'client-typegroupeclient',
          fetchParams: { TypeGroup },
          valueField: 'Code',
          labelField: 'Libelle',
          joinParam: 'ListGroup',
        },
      ]}
      fileNamePrefix="rapport_clients_groupe"
    />
  );
};

export default ListClientFRGroupe;